import { Theme } from "@mui/material/styles";
import { alpha, SystemStyleObject } from "@mui/system";

const keyMetricsStyles = {
  box: (theme: Theme, url: string): SystemStyleObject<Theme> => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: 4,
    height: 300,
    backgroundImage: `linear-gradient(0deg, ${alpha(
      theme.palette.background.default,
      0.7,
    )}, ${alpha(theme.palette.background.default, 0.7)}), url(${url})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    textAlign: "center",

    [theme.breakpoints.up("md")]: {
      height: 400,
    },
  }),
  value: (theme: Theme): SystemStyleObject<Theme> => ({
    fontSize: { xs: 40, md: 50, lg: 60 },
    fontWeight: 800,
    lineHeight: 1,
    mb: 2,
    color: theme.palette.secondary.main,
    textTransform: "uppercase",
    position: "relative",
  }),
  label: (theme: Theme): SystemStyleObject<Theme> => ({
    fontSize: { xs: 14, md: 16 },
    fontWeight: 600,
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    textTransform: "uppercase",
    position: "relative",
  }),
  itemWrapper: (): SystemStyleObject<Theme> => ({}),
};

export default keyMetricsStyles;
